import React, { useState, useEffect } from 'react';
import Link from 'next/link';
import AdmissionDate from '../../common/AdmissionDate';
import { ADMISSION_CONFIG } from '@/constants/admissionConfig';

const AdmissionBanner: React.FC = () => {
    const [mounted, setMounted] = useState(false);
    const [isAdmissionOpen, setIsAdmissionOpen] = useState(false);

    useEffect(() => {
        setMounted(true);
        if (ADMISSION_CONFIG.deadlineFull) {
            // Normalize date string (capitalize first letter of month) for better browser support
            const normalizedDate = ADMISSION_CONFIG.deadlineFull.charAt(0).toUpperCase() +
                ADMISSION_CONFIG.deadlineFull.slice(1);
            const deadline = new Date(normalizedDate).getTime();
            const now = new Date().getTime();

            if (!isNaN(deadline)) {
                setIsAdmissionOpen(deadline > now);
            } else {
                setIsAdmissionOpen(false);
            }
        }
    }, []);

    if (!mounted || !isAdmissionOpen) {
        return null;
    }

    return (
        <div className="admission-banner">
            <div className="container-fluid p-0">
                <div className="admission-marquee">
                    <Link href="/admission" className="admission-badge text-decoration-none">
                        <span className="pulse-dot"></span>
                        <div className="flip-text-wrapper">
                            <span className="flip-text-item">ADMISSION OPEN <AdmissionDate type="academicYearShort" asFragment /></span>
                            <span className="flip-text-item"><AdmissionDate type="remainingDays" asFragment /></span>
                        </div>
                    </Link>
                    <div className="marquee-content">
                        <Link href="/admission" className="marquee-content-wrapper">
                            <span className="admission-text">
                                <i className="fa-solid fa-graduation-cap me-2"></i>
                                Admissions Open for the Academic Session <AdmissionDate />-Apply Now!
                            </span>
                        </Link>
                        <Link href="/admission" className="marquee-content-wrapper">
                            <span className="admission-text">
                                <i className="fa-solid fa-graduation-cap me-2"></i>
                                Join Cayman Academy !
                            </span>
                        </Link>
                        <Link href="/admission" className="marquee-content-wrapper">
                            <span className="admission-text">
                                <i className="fa-solid fa-graduation-cap me-2"></i>
                                Admissions Open for the Academic Session <AdmissionDate />-Apply Now!
                            </span>
                        </Link>
                        <Link href="/admission" className="marquee-content-wrapper">
                            <span className="admission-text">
                                <i className="fa-solid fa-graduation-cap me-2"></i>
                                Join Cayman Academy !
                            </span>
                        </Link>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default AdmissionBanner;

